import { Bonus } from "@/types/common";

export const badgeByBonus: Record<Bonus, string> = {
  arbitrum: "/images/bonuses/arbitrum.png",
  eigenLayer: "/images/bonuses/eigenlayer.png",
  turtleDao: "/images/bonuses/turtleDao.png",
  etherFi: "/images/bonuses/etherfi.png",
  mellow2: "/images/bonuses/mellow2.png",
  kelp: "/images/bonuses/kelp.png",
  kelp2: "/images/bonuses/kelp2.png",
};
